import { render, staticRenderFns } from "./ExhibitionBoard.vue?vue&type=template&id=7becbdfc&scoped=true"
import script from "./ExhibitionBoard.vue?vue&type=script&lang=js"
export * from "./ExhibitionBoard.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionBoard.vue?vue&type=style&index=0&id=7becbdfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7becbdfc",
  null
  
)

export default component.exports